module.exports = __webpack_public_path__ + "static/Abacus Bewerberstamm-e6d1ed2367ff6d1285a5a9f342e3edea.png";